export const CALL_EVENTS = {
  cancelled: "cancelled",
  disconnected: "disconnected",
}
